// Obtener los metafields de un producto
function getVariantMetafields(productHandle, variantId) {
  return fetch('/api/2022-01/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': '7cb75f36635b9640261bc3d1d144e96a',
    },
    body: JSON.stringify({
      query: `
        {
          productByHandle(handle: "${productHandle}") {
            id
            variants(first: 100) {
              edges {
                node {
                  id
                  title
                  related_variants_soles: metafield(namespace: "pdw", key: "related_variants_soles") {
                    id
                    namespace
                    key
                    value
                  }
                  related_variants_toes: metafield(namespace: "pdw", key: "related_variants_toes") {
                    id
                    namespace
                    key
                    value
                  }
                  related_variants_instep: metafield(namespace: "pdw", key: "related_variants_instep") {
                    id
                    namespace
                    key
                    value
                  }
                }
              }
            }
          }
        }
      `,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      const edges = data.data.productByHandle.variants.edges;
      const specificEdge = edges.find((edge) => edge.node.id === `gid://shopify/ProductVariant/${variantId}`);
      return specificEdge;
    })
    .catch((error) => console.error('Error:', error));
}

// Añade productos al carrito
// Añade 2 suelas relacionadas
// Añade 1 empeine y 1 puntera- No se contabilizan, se añaden solo para poder mostrarlos en el carrito
async function addProductsToCart(_itemsToAdd) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ items: _itemsToAdd }),
  })
    .then((response) => response.json())
    .then((data) => {
      // Guardamos una copia del carrito en localStorage para que coincidan el mismo número de lineas (cart y localstorage cart) cuando se cargue la página del carrito
      return saveCart();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

// Modificar productos del carrito (actualizar cantidades por linea de carrito)
async function updateProductsToCart(_itemsToUpdate) {
  let updates = _itemsToUpdate;
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ updates: _itemsToUpdate }),
    //body: JSON.stringify({ updates }),
  })
    .then((response) => response.json())
    .then((data) => {
      //console.log('Productos eliminados del carrito:', data);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

// Elimina todos los productos del carrito
async function clearCart() {
  return (
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      // .then((data) => console.log('carrito vaciado: ', data))
      .catch((error) => {
        console.error('Error:', error);
      })
  );
}
